import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

// Actions
import { actions as staticPagesActions } from 'modules/staticpages/actions'

// Hooks
import { useStaticPageByPath } from 'modules/staticpages/hooks'

// Components
import SEO from 'components/base/seo'
import Grid from 'components/collection/grid'
import { CollectionsFilter } from 'components/filter'
import { StreamField } from 'components/staticpages/streamfield'
import { PageHeading, Section, Shelf, Entity, Error } from '@tracklib/kit'

// Types
import { Dispatch } from 'types'

const ShelvesLoading = () => (
  <Shelf>
    {[0, 1, 2, 3, 4].map(x => (
      <Shelf.Item key={x}>
        <Entity loading size={4} />
      </Shelf.Item>
    ))}
  </Shelf>
)

export const loadInitialData = () => async (dispatch: Dispatch) => {
  return dispatch(staticPagesActions.loadPageByPath('collections'))
}

const CollectionsPage = () => {
  const dispatch = useDispatch()
  const { search } = useLocation()
  const { page, request } = useStaticPageByPath('collections')
  const pageId = page?.id
  const searchQuery = `${search}&browse=1`
  const collectionsHeading = search ? 'Search results' : 'Themed collections'

  useEffect(() => {
    if (!page && !request.isLoading && !request.hasError && pageId && !request.isDone) {
      dispatch(staticPagesActions.loadPage(pageId))
    }
  }, [dispatch, request, page, pageId])

  return (
    <>
      <SEO title="Collections | Tracklib" />
      <PageHeading
        heading="Collections"
        description="Be inspired and find your next favorite sample with our selection of curated collections of songs and loops."
      />
      <Section>
        <CollectionsFilter />
      </Section>
      {!page && !request.isDone && <ShelvesLoading />}
      {((!page && request.isDone) || request.hasError) && <Error />}
      {page && !search && <StreamField blocks={page.content} />}
      <Section heading={collectionsHeading}>
        <Grid searchQuery={searchQuery} />
      </Section>
    </>
  )
}

export default CollectionsPage
